import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoCeb: CultureInfo = {
  name: 'ceb',
  displayName: 'Cebuano',
  iso3LanguageCode: 'ceb',
  iso2LanguageCode: 'ceb',
  ietfLanguageTag: 'ceb',
  parent: null
};
